import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import FeaturesTableCell from './FeaturesTableCell';
import FeaturesTableRow from './FeaturesTableRow';
import { FeaturesContext } from './FeaturesProvider';
import { CenteredSpinner } from './FeatureStyledComponents';

const FeaturesTableRows = () => {
  const {
    features,
    highlightedProducts,
    productLine
  } = useContext(FeaturesContext);
  const highestTier = highlightedProducts[highlightedProducts.length - 1];

  if (!features[productLine]) {
    return /*#__PURE__*/_jsx("tr", {
      children: /*#__PURE__*/_jsx("th", {
        children: /*#__PURE__*/_jsx(CenteredSpinner, {
          size: "medium"
        })
      })
    }, "loading");
  }

  const productLineFeatures = features[productLine];
  const filteredFeatures = productLineFeatures.filter(feature => !feature.hideFromLang);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: filteredFeatures.map(feature => {
      return /*#__PURE__*/_jsx(FeaturesTableRow, {
        feature: feature,
        highestTier: highestTier,
        children: highlightedProducts.map(apiName => {
          return /*#__PURE__*/_jsx(FeaturesTableCell, {
            feature: feature,
            apiName: apiName
          }, apiName);
        })
      }, feature.featureId);
    })
  });
};

export default FeaturesTableRows;